import { render } from "./NavbarLeft.vue?vue&type=template&id=fc48dd5c&scoped=true"
import script from "./NavbarLeft.vue?vue&type=script&lang=js"
export * from "./NavbarLeft.vue?vue&type=script&lang=js"

import "./NavbarLeft.vue?vue&type=style&index=0&id=fc48dd5c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc48dd5c"]])

export default __exports__